import { render, staticRenderFns } from "./dialog-confirm-checkbox.vue?vue&type=template&id=3257714c&"
import script from "./dialog-confirm-checkbox.vue?vue&type=script&lang=js&"
export * from "./dialog-confirm-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports